// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#autoComplPicNm {\n  position: absolute;\n  min-width: 300px;\n  max-height: 300px;\n  border: 1px solid #d8d8d8;\n  z-index: 999;\n  overflow: hidden;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
